<div class="not-found-container flex items-center justify-center min-h-screen bg-slate-50 p-4">
    <div class="text-center max-w-lg w-full">
        <!-- Modern 404 Illustration placeholder or stylized text -->
        <div class="error-illustration mb-8 relative">
            <h1
                class="text-[120px] md:text-[160px] font-black leading-none tracking-tighter text-slate-200 select-none">
                404
            </h1>
            <div class="absolute inset-0 flex items-center justify-center">
                <div class="w-32 h-32 md:w-40 md:h-40 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
            </div>
        </div>

        <div class="content-wrapper relative z-10 -mt-10 md:-mt-14">
            <h2 class="text-2xl md:text-3xl font-bold text-slate-800 mb-3">
                Lost in the System?
            </h2>
            <p class="text-slate-600 mb-8 max-w-sm mx-auto leading-relaxed">
                The page you're looking for seems to have vanished or moved to a different coordinate. Let's get you
                back on track.
            </p>

            <button (click)="goHome()"
                class="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-blue-200">
                <i class="bi bi-house-door-fill"></i>
                <span>Back to Home</span>
            </button>
        </div>

        <div class="mt-12 text-slate-400 text-sm">
            <p>&copy; {{ 2026 }} Sustain & Save. All rights reserved.</p>
        </div>
    </div>
</div>